import React from 'react'
import DataTag from './DataTag'

import '../App.css'
import '../styles/main.scss'
import '../styles/neighborhood.scss'
import '../styles/mapkey.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default function BuildingInfo(props) {
    const panelStyle = () => {
        if (props.panel.building){
            return {
                position: 'absolute',
                zIndex: '1',
                height: '73vh',
                width: '23em',
            }
        }
    }
    const contentStyle = () => {
        if (props.panel.building){
            return {
                overflowY: 'scroll',
                height: '90%'
            }
        }
    }

    return (
        <div className="component" style={panelStyle()}>
            <div className="card-header">
                <div className="header-front">
                <FontAwesomeIcon icon={['fa', 'building']} size="2x" className="font-awesome-spacing"/>
                    <h2 className="text-header">Building</h2>
                </div>    
                <button id="building" onClick={props.expandClick} className="expand-icon">
                            {props.panel.building ? 
                             <FontAwesomeIcon icon={['fa', 'minus']} className="font-awesome-win"/> :
                             <FontAwesomeIcon icon={['far', 'window-maximize']} className="font-awesome-win"/>
                            }
                </button>
            </div>

            <div className="card-content" style={contentStyle()}>
                <DataTag 
                    heading1={'# Buildings on Lot'}
                    content1={props.numBldg === undefined ? 'N/A' : props.numBldg}
                    heading2={'Landmark'}
                    content2={props.landmark === undefined || props.landmark === null ? 'N/A' : props.landmark}
                />
                <DataTag 
                    heading1={'Max Floors'}
                    content1={props.numFloors === undefined ? 'N/A' : props.numFloors}
                    heading2={'Year Built'}
                    content2={props.yearBuilt === undefined ? 'N/A' : props.yearBuilt}
                />
                <h3 className="text-light">Building Class</h3>
                <h2 className="text-bold">{props.bldgClass === undefined ? 'N/A' : props.bldgClass}</h2>
      
                <h3 className="text-light">Building Stats</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Value</th>
                            <th>Quantity</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Built FAR</td>
                        <td>{props.builtFAR}</td>
                    </tr>
                    <tr>
                        <td>Building Area</td>
                        <td>{props.bldgArea} sf</td>
                    </tr>            
                    <tr>
                        <td>Building Depth</td>
                        <td>{props.bldgDepth} ft</td>
                    </tr> 
                    <tr>
                        <td>Building Front</td>
                        <td>{props.bldgFront} ft</td>
                    </tr> 
                    </tbody>
                </table>
            
            </div>
            
        </div>
    )

}